var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed',{ref:"svgIcon",class:_vm.svgClass,attrs:{"src":`/svg-icons/${_vm.iconClass}.svg`}})
}
var staticRenderFns = []

export { render, staticRenderFns }